import React, { useEffect, useState } from "react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import ppidDoc from "assets/images/icons/ppid-doc.svg";
import icons from "assets/images/icons/icons.svg";
import { downloadFile } from "utils/myFunc";
import { uAPI } from "api/config";

function File({ file }) {
  const gradientStyle = {
    background: "linear-gradient(to right, #1C3865, #1C80B9, #36B4E5)",
  };
  const lang = localStorage.getItem("i18nextLng");

  // State untuk dropdown
  const [isOpen, setIsOpen] = useState({});

  // Update state jika file berubah
  useEffect(() => {
    if (file) {
      const initialDropdownState = file.reduce((acc, _, index) => {
        acc[index] = false;
        return acc;
      }, {});
      setIsOpen(initialDropdownState);
    }
  }, [file]);

  // Toggle dropdown berdasarkan index
  const toggleDropdown = (index) => {
    setIsOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="flex-1 p-6 md:grid-cols-9 md:block">
      <div className="flex-1 flex-col sm:my-5 mx-2 md:mx-20 text-justify">
        {file?.map((val, ind) => (
          <div key={ind} className="my-10 mx-2">
            <div className="mb-2 lg:border lg:rounded-lg rounded-sm" style={{ width: "100%" }}>
              {/* HEADER */}
              <div
                className="text-white align-middle font-medium lg:rounded-t-lg lg:rounded-lg text-lg px-2 lg:py-4 py-2 flex flex-row-reverse cursor-pointer hover:opacity-90 border-b css-ck7407 w-full"
                onClick={() => toggleDropdown(ind)}
                style={gradientStyle}
              >
                <ChevronUpIcon
                  className={`${
                    isOpen[ind] ? "rotate-180 transform" : ""
                  } h-5 w-5 text-primary-500`}
                />
                <div className="flex-auto mt-1 text-lg">
                  {lang === "en" ? val?.title_en || val?.title : val?.title}
                </div>
                <div className="px-2">
                  <img src={icons} className="flex justify-left" alt="ppic-info" />
                </div>
              </div>

              {/* DROPDOWN CONTENT */}
              <div
                className={`lg:px-4 px-2 py-2 text-justify text-left text-gray-800 lg:mb-5 mb-3 bg-white ${
                  isOpen[ind] ? "block" : "hidden"
                }`}
                style={{ width: "100%" }}
              >
                {val?.subdetail?.map((value, i) => (
                  <div
                    key={i}
                    className="flex lg:flex-row lg:justify-between flex-col border my-3 lg:px-8 px-4 py-2 lg:rounded-xl rounded-md cursor-pointer font-medium text-gray-700 hover:bg-gray-100"
                  >
                    <div className="flex items-center lg:mr-8 lg:text-left text-center">
                      <div style={{ marginRight: "10px" }}>
                        <img src={ppidDoc} alt="ppic-info" />
                      </div>
                      {lang === "en" ? value?.title_en || value?.title : value?.title}
                    </div>
                    <div className="flex justify-center">
                      {value?.path.includes("/files") ? (
                        <>
                          <a
                            href={uAPI + value?.path}
                            target="_blank"
                            className="flex items-center border rounded-md py-1 px-8 text-white lg:text-sm text-xs"
                            style={{ backgroundColor: "#2FB6E9" }}
                          >
                            View
                          </a>
                          <a
                            onClick={() => downloadFile(value?.path)}
                            target="_blank"
                            className="flex items-center border rounded-md py-1 px-8 text-white lg:text-sm text-xs"
                            style={{ backgroundColor: "#2FB6E9" }}
                          >
                            Unduh
                          </a>
                        </>
                      ) : (
                        <a
                          href={value?.path}
                          target="_blank"
                          className="flex items-center border rounded-md py-1 px-8 text-white lg:text-sm text-xs"
                          style={{ backgroundColor: "#2FB6E9" }}
                        >
                          View
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default File;
